module.exports = __webpack_public_path__ + "img/collection-fill.2c210cdf.svg";